import React, { useEffect, useRef } from 'react';
import { Box, FlexControlledForm, useDebounceState } from '@common-fe/common-fe';
import _ from 'lodash';

import { useAccountFundingParamsStore } from '../../AccountFunding/AccountFundingParams/stores';
import { PLAN_SETUP_FIELD } from '../../PlanSetup.constants';
import { useSubmitFormStore } from '../../stores';

import usePlanNameStore, { PlanNamePayload } from './stores/usePlanName.store';
import { usePlanNameFields } from './hooks';

interface Props {
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  onDirty?: (isDirty: boolean) => void;
}
const PlanName: React.FC<Props> = ({ isEditMode, isTemplateMode, onDirty }) => {
  const saveValidate = useSubmitFormStore((state) => state.saveValidate);
  const activateValidate = useSubmitFormStore((state) => state.activateValidate);
  const fields = usePlanNameFields(false, isTemplateMode, isEditMode);
  const handleSetState = usePlanNameStore((state) => state.setState);
  const showErrors = usePlanNameStore((state) => state.showErrors);
  const accountFundingErrorFields = useAccountFundingParamsStore((state) => state.errorFields);
  const setAccountFundingErrorFields = useAccountFundingParamsStore((state) => state.setErrorFields);
  const { setValues, values } = useDebounceState<Partial<PlanNamePayload>>();
  const prevPriorPlanId = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);
  // On an ACTIVE plan the Funding Method field is disabled, so the backend
  // FUNDING_METHOD_SAME_AS_PRIOR error stays stuck and keeps Save/Activate blocked.
  // Changing the Prior Plan is the only action the user has to resolve it, so we
  // clear that stuck error whenever priorPlanId actually changes.
  useEffect(() => {
    const nextPriorPlanId = values?.priorPlanId;
    if (nextPriorPlanId === undefined) return;

    const priorPlanChanged =
      prevPriorPlanId.current !== undefined && nextPriorPlanId !== prevPriorPlanId.current;
    prevPriorPlanId.current = nextPriorPlanId;

    if (priorPlanChanged && accountFundingErrorFields?.fundingMethod) {
      setAccountFundingErrorFields(_.omit(accountFundingErrorFields, PLAN_SETUP_FIELD.FUNDING_METHOD));
    }
  }, [values, accountFundingErrorFields, setAccountFundingErrorFields]);
  return (
    <Box background="canvas" round="container1Round">
      <FlexControlledForm
        testId="plan_primary-definition"
        fields={fields}
        showError={showErrors || saveValidate || activateValidate}
        editMode={isEditMode}
        onChangeValues={setValues}
        onDirty={onDirty}
        // isDisabledMode
        isThinMode
      />
    </Box>
  );
};
export default PlanName;
